import React, { Component } from "react";

export default class Footer extends Component {
  componentDidMount() {
    const intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "x6oeppkc",
    };

    if (this.props.userId && this.props.userEmail) {
      intercomSettings.user_id = this.props.userId;
      intercomSettings.email = this.props.userEmail;
    }

    window.intercomSettings = intercomSettings;

    if (window.Intercom) {
      window.Intercom("reattach_activator");
      window.Intercom("update", intercomSettings);
    } else {
      const intercomScript = document.createElement("script");
      intercomScript.type = "text/javascript";
      intercomScript.async = true;
      intercomScript.src = `https://widget.intercom.io/widget/x6oeppkc`;
      intercomScript.onload = () => window.Intercom("update", intercomSettings);
      document.body.appendChild(intercomScript);
    }
  }

  render() {
    return (
      <footer>
        <div className="footer_main">
          <div className="footer_main_left">
            <div className="full-logo">
              <a href="/">
                <img src={"./images/synaptiq-logo-full.svg"} alt="" />
              </a>
            </div>
          </div>
          <div class="footer_main_right">
            <div class="link-set">
              <div class="section-label">Legacy Synaptiq</div>
              <div class="links">
                <div>
                  <a href="/library">Thieme x Synaptiq</a>
                </div>
                <div>
                  <a href="https://www.synaptiq.app/">Sign In</a>
                </div>
                <div>
                  <a href="https://www.synaptiq.app/users/sign_up">Sign Up</a>
                </div>
              </div>
            </div>
            <div class="link-set">
              <div class="section-label">Connect</div>
              <div class="links">
                <div>
                  <button
                    id="get-technical-support"
                    onClick={() => {
                      window.Intercom("showNewMessage");
                    }}
                  >
                    Contact
                  </button>
                </div>
              </div>
            </div>
            <div class="link-set">
              <div class="section-label">Ora</div>
              <div class="links">
                <div>
                  <a href="https://www.oraai.com/terms">Terms of Use</a>
                </div>
                <div>
                  <a href="https://www.oraai.com/privacy">Privacy Policy</a>
                </div>
              </div>
              <div class="section-label" style={{ marginTop: "1.5rem" }}>
                Synaptiq
              </div>
              <div class="links">
                <div>
                  <a href="/terms">Terms of Use</a>
                </div>
                <div>
                  <a href="/privacy">Privacy Policy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_sub">
          Synaptiq Learning Inc. | &copy; 2026 | All Rights Reserved
        </div>
      </footer>
    );
  }
}
